import React, { Component } from "react";
import Box from "./Box";
import "./Page.css";

class Page extends Component {
  render() {
    return (
      <div className="container">
        <Box no={1} />
        <Box no={2} />
        <Box no={3} />
        <Box no={4} />
        <Box no={5} />
        <Box no={6} />
        <Box no={7} />
        <Box no={8} />
        <Box no={9} />
        <Box no={10} />
        <Box no={11} />
        <Box no={12} />
        <Box no={13} />
        <Box no={14} />
        <Box no={15} />
        <Box no={16} />
        <Box no={17} />
        <Box no={18} />
        <Box no={19} />
        <Box no={20} />
        <Box no={21} />
      </div>
    );
  }
}

export default Page;
